import { createGlobalStyle } from 'styled-components';
import { roadmapViewStyles } from 'tabview/roadmap2026/roadmapViewStyles';

export const LegacyRoadmapViewStyle = createGlobalStyle`
  .roadmap-view {
    ${roadmapViewStyles}
  }
`;
